import { computed, signal } from '@preact/signals-core';

export interface Organization {
    id: number;
    name: string;
    slug?: string;
    role?: string;
}

export const organizations = signal<Organization[]>([]);
export const currentOrganization = signal<Organization | null>(null);
export const isLoadingOrgs = signal(false);
export const needsOrgSelection = signal(false);
// Tracks if organization was set from WorkOS login (hide switcher if true)
export const orgSetFromLogin = signal(false);

export const hasMultipleOrgs = computed(() => organizations.value.length > 1);

export const clearOrganizationState = () => {
    organizations.value = [];
    currentOrganization.value = null;
    isLoadingOrgs.value = false;
    needsOrgSelection.value = false;
    orgSetFromLogin.value = false;
};
